import React from 'react';
import UserManagement from '../components/UserManagement';

function UserManagementPage() {
  return <UserManagement />;
}

export default UserManagementPage;

